import React from "react";

export default class BlogPost extends React.Component 
{
    constructor(props)
    {
        super(props)
        this.post = this.props.post
    }    

    getImage = (image) =>
    {
        if(image === null)
        {
            return(<></>)
        }

        const alt = image.alt !== '' ? image.alt : 'hometown';
        
        return(
            <div className="main-image">
                <img src={image.path} alt={alt}/>
            </div>
        )
    }
    getUpdatedDate = (date) => {
        if(!date) return (<></>)
        const formatedDate = new Date(date)
        return 'Updated ' + formatedDate.toLocaleDateString('en-us', { day:"numeric", year:"numeric", month:"long"})
    }
    
    getTxt = (text) =>
    {
        let txt = text       
        txt = txt.replace(/<table/g, "<div style='overflow:auto;'><table")    
        txt = txt.replace(/\/table>/g, "\/table></div>") 
        return txt
    }


    render() 
    {    
        return (
            <div className="post">  
                {this.getImage(this.post.image)}
                <ul className="tags">
                {                
                    this.post.tags.map(tag =>
                    {                        
                        return (
                            tag.id !== 'success' ? (
                            <li class="big"><a href={'/blog/tags/'+tag.slug}>{tag.name}</a></li>
                            ) : (
                            <li class="big"><a href={'/pro/guide/tags/'+tag.slug}>{tag.name}</a></li>
                            )
                        )
                    })
                }
                </ul>
                <p className="changedDate">{this.getUpdatedDate(this.post.changed)}</p>
                <div className="body" dangerouslySetInnerHTML={{__html: this.getTxt(this.post.content)}}></div>
            </div>   
        )
    }
};